const colors = {
  maleBackground: "#DBEAFE",
  femaleBackground: "#FBCFE8",
  maleSymbol: "#EFF6FF",
  femaleSymbol: "#EC4899",
  linkColor: "#007BFF",
  grayMedium: "#374151",
  grayLight: "#6B7280",
};

export default colors;
